module.exports = __webpack_public_path__ + "static/media/tnw.84a6c7ac.png";